"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAddressBookToAddressBooksData = addAddressBookToAddressBooksData;
exports.addGroupToAddressBookData = addGroupToAddressBookData;
exports.refreshButton = refreshButton;
var _solidLogic = require("solid-logic");
var _texts = require("../../texts");
var _buttonsHelper = require("../../buttonsHelper");
var _selectors = require("./selectors");
var _profileIcons = require("../../icons-svg/profileIcons");
const addAsContactButtonText = 'Add as Contact';
function setAddToContactsButtonContent(button, label, showIcon = false) {
  if (!button) return;
  const {
    ownerDocument
  } = button;
  const content = [];
  if (showIcon) {
    const iconWrapper = ownerDocument.createElement('span');
    iconWrapper.className = 'profile__btn-contacts-icon inline-flex-row justify-center';
    iconWrapper.setAttribute('aria-hidden', 'true');
    renderIconIntoElement(iconWrapper);
    content.push(iconWrapper);
  }
  const labelWrapper = ownerDocument.createElement('span');
  labelWrapper.className = 'profile__btn-contacts-label';
  labelWrapper.textContent = label;
  content.push(labelWrapper);
  button.replaceChildren(...content);
}
function renderIconIntoElement(element) {
  const svgTemplate = _profileIcons.plusIcon;
  if ('innerHTML' in element && svgTemplate && Array.isArray(svgTemplate.strings)) {
    element.innerHTML = svgTemplate.strings.join('');
  }
}
function refreshButton(context, addressBooksData, contactData) {
  const me = _solidLogic.authn.currentUser();
  const button = context.dom.getElementById('add-to-contacts-button');
  if ((0, _buttonsHelper.checkIfAnyUserLoggedIn)(me)) {
    const contactExistsByWebID = (0, _selectors.checkIfContactExistsByWebID)(addressBooksData, contactData.webID);
    const contactExistsByName = (0, _selectors.checkIfContactExistsByName)(addressBooksData, contactData.name);
    if (contactExistsByWebID) {
      setAddToContactsButtonContent(button, _texts.contactExistsAlreadyButtonText);
      button.onclick = null;
      button.setAttribute('disabled', '');
    } else if (contactExistsByName) {
      setAddToContactsButtonContent(button, _texts.contactExistsAlreadyByNameButtonText);
      button.removeAttribute('disabled');
    } else {
      setAddToContactsButtonContent(button, addAsContactButtonText, true);
    }
  } else {
    setAddToContactsButtonContent(button, _texts.logInAddMeToYourContactsButtonText);
  }
}
function addGroupToAddressBookData(addressBooksData, addressBookUri, group) {
  const publicAddressBook = addressBooksData.public.get(addressBookUri);
  if (publicAddressBook) {
    const groupExists = publicAddressBook.groups.some(existingGroup => existingGroup.uri === group.uri);
    if (!groupExists) {
      addressBooksData.public.set(addressBookUri, {
        ...publicAddressBook,
        groups: [...publicAddressBook.groups, group]
      });
    }
    return true;
  }
  const privateAddressBook = addressBooksData.private.get(addressBookUri);
  if (privateAddressBook) {
    const groupExists = privateAddressBook.groups.some(existingGroup => existingGroup.uri === group.uri);
    if (!groupExists) {
      addressBooksData.private.set(addressBookUri, {
        ...privateAddressBook,
        groups: [...privateAddressBook.groups, group]
      });
    }
    return true;
  }
  return false;
}
function addAddressBookToAddressBooksData(addressBooksData, addressBookUri, addressBook, visibility = 'private') {
  const nextAddressBooksData = {
    public: new Map(addressBooksData.public),
    private: new Map(addressBooksData.private),
    contactWebIDs: addressBooksData.contactWebIDs,
    contactNames: addressBooksData.contactNames
  };
  const existingAddressBook = nextAddressBooksData.public.get(addressBookUri) || nextAddressBooksData.private.get(addressBookUri);
  const nextAddressBook = existingAddressBook ? {
    ...existingAddressBook,
    ...addressBook,
    groups: addressBook.groups.length ? addressBook.groups : existingAddressBook.groups,
    contacts: addressBook.contacts.length ? addressBook.contacts : existingAddressBook.contacts
  } : addressBook;
  nextAddressBooksData.public.delete(addressBookUri);
  nextAddressBooksData.private.delete(addressBookUri);
  nextAddressBooksData[visibility].set(addressBookUri, nextAddressBook);
  return nextAddressBooksData;
}